import React from 'react';
import './styles.css';

export default function Header(){
    
    return <header className="header">
        
        <h1 className="header-title"><span>React Pokédex</span></h1>
        <h2>Andrew Newport ・Rachel Lin ・ Jessica Link</h2>  
        </header>;
}
